import { useContext, useState } from "react";
import { useMutation, useQueryClient } from "react-query";
import { AxiosContext } from "services/axios.context";

const useCreateAuctionBenefit = (productID, auctionID) => {
  const { client } = useContext(AxiosContext);
  const [error, setError] = useState("");
  const queryClient = useQueryClient();
  return {
    createAuctionBenefit: useMutation(
      (params) => {
        client
          .post(`/products/${productID}/benefits/`, params)
          .then((res) => res.data);
      },
      {
        onSuccess: () => {
          queryClient.invalidateQueries(`auction-benefits`);
        },
      }
    ),
    error: error,
  };
};

export default useCreateAuctionBenefit;
